module.exports = __webpack_public_path__ + "static/media/logo-new.2563b421158b7fe0de900c81592c469c.png";